//3rd Party Components
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from 'react';
import axios from 'axios';

//Components

//Actions
import { getSPFileDetails, FETCH_SPFILEDETAILS_SUCCESS } from '../../PortalStore/Actions/SPFileDetailsActions';
import { addPageAlert } from '../../PortalStore/Actions/PageAlertActions';
import { getUrlSelector } from '../../PortalStore/Selectors/EnvDataSelectors';

const SharePointDownload = ({ entity, id, ios, file, load }) => {
    const [pageLoading, setPageLoading] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [pageLoadedError, setPageLoadedError] = useState(false);
    const [pageLoadedErrorMessage, setPageLoadedErrorMessage] = useState("");

    const dispatch = useDispatch();
    const webappurl = useSelector(state => state.B2CSettings.items.webappurlPortalApi);
    const accessTokenPortal = useSelector(state => state.B2CSettings.items.accesstokenPortal);

    let urlHome = useSelector(state => getUrlSelector(state, "Portal - Home URL"));
    let spId = useSelector(state => state.SPFileDetails.items.spId);
    let spFile = useSelector(state => state.SPFileDetails.items.file);

    useEffect(() => {
        if (pageLoading) {
            return;
        }
        if (!pageLoaded && !pageLoadedError) {
            setPageLoading(true);
            axios.all([
                dispatch(getSPFileDetails(webappurl, accessTokenPortal, entity, ios, id, file))
            ])
                .then(axios.spread((spfilesres) => {
                    if (spfilesres.type === FETCH_SPFILEDETAILS_SUCCESS) {
                        setPageLoaded(true);
                        setPageLoading(false);
                    }
                    else {
                        setPageLoadedError(true);
                        setPageLoadedErrorMessage("SP.1");
                        setPageLoading(false);
                        setPageLoaded(true);

                        let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                        let details = "Details: SP.1";
                        dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                    }
                }))
                .catch(function (error) {
                    setPageLoadedError(true);
                    setPageLoadedErrorMessage("SP.2");
                    setPageLoading(false);
                    setPageLoaded(true);

                    let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                    let details = "Details: SP.2";
                    dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                });
        }

        if (pageLoaded && !pageLoadedError) {
            if (ios === 'true') {
                window.parent.open(urlHome + '/_entity/sharepointdocumentlocation/' + spId + '?file=' + spFile, '_blank');
            }
            else {
                if (ios === 'firefox') {
                    window.open(urlHome + '/_entity/sharepointdocumentlocation/' + spId + '?file=' + spFile);
                    window.close();
                }
                else {
                    window.open(urlHome + '/_entity/sharepointdocumentlocation/' + spId + '?file=' + spFile);
                }
            }
            load(false);
        }

        if (pageLoaded && pageLoadedError) {
            //redirect to error page
            load(false);
        }

    }, [pageLoading, pageLoaded, pageLoadedError, pageLoadedErrorMessage, accessTokenPortal, webappurl, spId, dispatch, entity, file, id, ios, load, spFile, urlHome]);

    return (<Fragment />);
}

SharePointDownload.propTypes = {
    entity: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    ios: PropTypes.string.isRequired,
    file: PropTypes.string.isRequired,
    load: PropTypes.func.isRequired,
};

export default SharePointDownload;
